(() => {
  const storagePrefix = 'swu-cart-countdown-end-';
  let fallbackEnd = 0;
  function tick() {
    document.querySelectorAll('[data-swu-timer]').forEach((timer) => {
      const storageKey = storagePrefix + (timer.dataset.minutes || '10');
      let end = fallbackEnd;
      try { end = Number(sessionStorage.getItem(storageKey)) || 0; } catch (_) {}
      if (!end) {
        end = Date.now() + Number(timer.dataset.minutes || 10) * 60000;
        fallbackEnd = end;
        try { sessionStorage.setItem(storageKey, String(end)); } catch (_) {}
      }
      const remaining = Math.max(0, Math.ceil((end - Date.now()) / 1000));
      if (!remaining) { timer.textContent = timer.dataset.expired; return; }
      const clock = timer.querySelector('[data-swu-clock]');
      if (clock) clock.textContent = String(Math.floor(remaining / 60)).padStart(2, '0') + ':' + String(remaining % 60).padStart(2, '0');
    });
  }
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-swu-add]');
    if (!button || button.disabled) return;
    const card = button.closest('.swu-upsell'), select = card.querySelector('[data-swu-variant]'), error = card.querySelector('.swu-upsell__error');
    const drawer = document.querySelector('cart-drawer');
    button.disabled = true; error.hidden = true;
    try {
      const sections = drawer.getSectionsToRender().map((section) => section.id);
      const response = await fetch(button.dataset.addUrl + '.js', { method: 'POST', headers: {'Content-Type':'application/json','Accept':'application/json'}, body: JSON.stringify({items:[{id:Number(select ? select.value : button.dataset.variant), quantity:1}], sections, sections_url: window.location.pathname}) });
      const data = await response.json();
      if (!response.ok || data.status) throw new Error(data.description || 'Unable to add this product.');
      drawer.classList.remove('is-empty'); drawer.renderContents(data);
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, {source:'swu-upsell', cartData:data});
      setTimeout(tick, 100);
    } catch (e) { error.textContent = e.message || 'Unable to add this product.'; error.hidden = false; button.disabled = false; }
  });
  document.addEventListener('DOMContentLoaded', tick);
  setInterval(tick, 1000);
})();
